export const GET_USER_ERROR_MSG =
    'Error retrieving user information. Please try again or contact support';
